import {defineStore} from 'pinia'

export const useCategoriesStore = defineStore('categories', {
    state: () => {
        return {
            /**
             * Remember: Profiles has a watcher in the CategoriesTab.vue to help organise entries into groups.
             */
            profiles: [],
            profilesInitialState: [],
            allCategoriesForCurrentSelectedProfile: [],
            /**
             * Has a watcher in ProfileSidebar.vue
             */
            currentSelectedProfile: {
                profileName: "",
                profileDescription: ""
            },
            whitelist: [],
            whitelistInitialState: [],
            blacklist: [],
            blacklistInitialState: [],
        }
    },
    actions: {

        setProfiles(profiles) {
            this.profiles = profiles
        },
        getProfiles() {
            return this.profiles
        },
        setProfilesInitialState(profiles) {
            this.profilesInitialState = profiles
        },
        getProfilesInitialState() {
            return this.profilesInitialState
        },
        getWhitelist() {
            return this.whitelist
        },
        setWhitelist(whitelist) {
            this.whitelist = whitelist
        },
        setWhitelistInitialState(whitelist) {
            this.whitelistInitialState = whitelist
        },
        getBlacklist() {
            return this.blacklist
        },
        setBlacklist(blacklist) {
            this.blacklist = blacklist
        },
        setBlacklistInitialState(blacklist) {
            this.blacklistInitialState = blacklist
        },
        getWhitelistInitialState() {
            return this.whitelistInitialState
        },
        getBlacklistInitialState() {
            return this.blacklistInitialState
        }

    }

})
